"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Generated by ../scripts/build-pkg-info.js at 2024-01-23T23:48:02.598Z
module.exports = { packageName: '@zillow/client-profiler-core', gitShortHash: '6916f71' };
